import {  Component           ,
          EventEmitter        ,
          Input               ,
          OnChanges,
          Output,
          SimpleChanges} from "@angular/core";
import {  ReactiveFormsModule } from "@angular/forms";
import {  SidebarModule       } from 'primeng/sidebar';
import {  FileUploadModule    } from 'primeng/fileupload';

import {  TranslatePipe       } from "nv@services/translate.service";

@Component({
  selector    : 'template-import',
  templateUrl : './template-import.component.html',
  imports     : [
    ReactiveFormsModule ,
    SidebarModule       ,
    SidebarModule       ,
    TranslatePipe       ,
    FileUploadModule
  ]
})
export class TemplateImport implements OnChanges {


  public ngOnChanges(changes: SimpleChanges): void {
    throw new Error("Method not implemented.");
  }

  @Input()  public $form: any;
  @Output() public onUpload = new EventEmitter();

  /**
   * @author Mihail Petrov
   */
  public downloadTemplate() {
    window.location.href='/assets/import_templates/import_sites.xlsx';
  }

  /**
   * @author Mihail Petrov
   * @param $event
   */
  public processEmit($event: any, $fu: any) {

    this.onUpload.emit($event);
    $fu.clear();
  }
}
